import React from "react";
import "./Culture.css";
import 'animate.css';
import FadeUp from "../FadeUp/FadeUp";

const Culture = ({ isAlbanian }) => {
  return (
    <div className="culture-container">
      <div className="overlay">
        <div className="vertical-line left"></div>
        <div className="vertical-line right"></div>

        <div className="culture-title">
          <FadeUp>{isAlbanian ? "Vizioni ynë" : "Our Vision"}</FadeUp>
        </div>

        <div className="vision-content">
          <div className="vision-right">
            <h2>
            <FadeUp>
              {(isAlbanian
                ? `Reputacioni i Vila-L gjatë viteve ka vendosur standarde të larta që do të udhëheqin të ardhmen e kompanisë. Siguria në punë, cilësia e ndërtimit dhe përkushtimi ndaj klientëve mbeten prioritetet tona kryesore, duke reflektuar vlerat mbi të cilat është ndërtuar suksesi ynë.\n
    Duke parë përpara, vizioni ynë synon:\n
    1.	Të zhvillojmë projekte të ndryshme, nga më të voglat te më të mëdhat, duke ofruar zgjidhje praktike dhe cilësore.\n 
    2.	Të zgjerojmë aktivitetin tonë përtej kufijve të Shqipërisë dhe Malit të Zi, duke hyrë në tregje të reja ndërkombëtare.\n 
    3.	Të integrojmë teknikat më të avancuara të ndërtimit, duke sjellë standarde më të larta në industrinë e ndërtimit.\n
    Me vizion të qartë dhe përkushtim, Vila-L vijon të ndërtojë të ardhmen me cilësi, besueshmëri dhe inovacion.`
                : `The reputation that Vila-L has built over the years has set high standards that will guide the company’s future. Workplace safety and dedication to our clients remain our top priorities, reflecting the values upon which our success is founded.\n
    Looking ahead, our vision aims to:\n
    1.	Develop projects of all types and scales, offering innovative and high-quality solutions.\n 
    2.	Expand our operations beyond Albania and Montenegro, entering new international markets.\n 
    3.	Integrate advanced construction techniques, setting higher industry standards.\n
    With a clear vision and commitment, Vila-L continues to build the future with quality, reliability, and innovation.`
              )
                .split("\n")
                .map((text, index) => (
                  <span key={index}>
                    {text}
                    <br />
                  </span>
                ))}
                </FadeUp>
            </h2>
          </div>

          <div className="vision-left">

            <img
              src="/vision.jpg"
              alt="vision-photo"
              className="vision-image"
              loading="lazy"
            />
          </div>
        </div>

        <div className="bottom-line"></div>
      </div>
    </div>
  );
};

export default Culture;
